import {
  FileCheck, ShieldCheck, Calculator, ClipboardCheck, BookOpen, LineChart,
  TrendingUp, Handshake, Scale, Megaphone, BadgeCheck, Rocket, Building2,
  ShoppingBag, Cloud, Landmark, Factory, MapPin, Phone, Mail, ArrowRight,
  Sparkles, Award, Users, FileText, Globe, CheckCircle2,
} from "lucide-react";

const MAP = {
  FileCheck, ShieldCheck, Calculator, ClipboardCheck, BookOpen, LineChart,
  TrendingUp, Handshake, Scale, Megaphone, BadgeCheck, Rocket, Building2,
  ShoppingBag, Cloud, Landmark, Factory, MapPin, Phone, Mail, ArrowRight,
  Sparkles, Award, Users, FileText, Globe, CheckCircle2,
};

export default function Icon({ name, ...props }) {
  const Cmp = MAP[name] || Sparkles;
  return <Cmp {...props} />;
}
